/**
 * "Show more" on the Followers screen grows one read's `limit` instead of
 * walking a cursor (ISSUE-1372). The list then stays a single generated
 * query, so every follow mutation's invalidation refreshes exactly what is
 * on screen, with no merged pages to fall out of date. A fan follows the
 * people they play with, a few dozen, so the server's 200 row clamp is the
 * real ceiling and is far above it.
 */
export const FOLLOW_LIST_PAGE_SIZE = 50;
export const FOLLOW_LIST_MAX_LIMIT = 200;

export function nextFollowListLimit(current: number): number {
  return Math.min(current + FOLLOW_LIST_PAGE_SIZE, FOLLOW_LIST_MAX_LIMIT);
}

/** Show more only while the server says there is more AND a bigger read can reach it. */
export function canShowMore(input: {
  limit: number;
  nextCursor: string | null | undefined;
}): boolean {
  return (
    input.nextCursor !== null &&
    input.nextCursor !== undefined &&
    input.limit < FOLLOW_LIST_MAX_LIMIT
  );
}
